import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { formatKambiCurrencyToDollarDecimal } from '@mobi/sports-offering/helpers/currency/currencyFormat'
import { KAMBI_PENDING_HASH_ROUTE } from '@core/Areas/KambiClient/constants'

export const SameGameMulti: React.FC<{
  historyCoupon: KambiHistoryCoupon
}> = ({ historyCoupon }) => {
  const { outcomes } = historyCoupon

  const bet = historyCoupon.bets[0]
  const odds = formatKambiCurrencyToDollarDecimal(bet.betOdds)
  const boostedOdds = bet.betOddsBoosted
    ? formatKambiCurrencyToDollarDecimal(bet.betOddsBoosted)
    : null

  return (
    <BetCard.SelectionInfo
      heading='Same Game Multi'
      subHeading={`${outcomes.length} Legs`}
      linkInfo={{ pathname: KAMBI_PENDING_HASH_ROUTE }}
      iconComponent={<Icon name='CustomSGM' size='2.4rem' />}
      priceWin={odds}
      priceWinBoosted={boostedOdds}
    />
  )
}
